import { MasterSheetList, MasterSheetEdit } from './views';

export default {
  edit: MasterSheetEdit,
  list: MasterSheetList,
  name: 'job-master-sheet-v2',
  label: 'TN Production List',
  to: '/job-master-sheet-v2',
  hasList: true,
  hasEdit: true,
  hasShow: false,
  hasCreate: false,
};